<div class="flex flex-row justify-between gap-3">
  <div class="image-slider">
    @for (image of images; track image) {
      <div class="image-slider-preview" (click)="loadImage(image)">
        @if (image.type === 'video') {
          <div class="video-overlay">
            <video [src]="image.url" [width]="80" [height]="80" [controls]="false" [autoplay]="false"></video>
            <mat-icon>play_arrow</mat-icon>
          </div>
        } @else {
          <img [ngSrc]="image.url" [alt]="image.image_name" [width]="80" [height]="80"/>
        }
      </div>
    }
  </div>
  <div class="image-slider-main">
    <div class="img-section">
      @if (!!selectedImage) {
        @if (selectedImage.type === 'video') {
          <video [src]="selectedImage.url" [controls]="true" [autoplay]="true" width="100%" height="100%" loop type='video/mp4'></video>
        } @else {
          <img [ngSrc]="selectedImage.url" [alt]="selectedImage.image_name" width="100" height="100"/>
        }
      } @else {
        <p>No image selected</p>
      }
    </div>
    <div>
      <p class="text-center p-2">{{ selectedImage?.image_name }}</p>
    </div>
  </div>
</div>
